import * as actionTypes from '../actionType';

const sendMessageState = {
  sendMessageDetail: {}, // 待办 结果获取需要发送的信息
  sendMessagesListObject: {}, // 获取发送对象的list
  sendMessagesListParams: {}, // 调用送对象的list的参数
  selectedSendMessageList: [],// 选中的发送对象list
  sendMessageResult: {}, // 是否发送成功
  sendMessageRestartSendResult: {}, // 补发结果
  sendReissueMessageParams: {
    pageNo: 1,
    pageSize: 20
  }, // 补发接口的参数
  sendReissueMessageListObject: {}, // 返回的补发列表
  // sendReissueMessageListId: [], // 获取到补发的列表id
  searchHistoryMessageParams: {}, // 历史列表接口的参数
  searchHistoryMessageListObject: {}, // 返回的 历史列表数据
  paramsConfigList: [], // 插入参数列表
  sendGroupMessageParams: {}, // 群消息参数
  selfCreatedSendMessageData: {},// 自定义上传的数据
  miniProgramParams: {}, //小程序列表参数
  miniProgramListObject: {} // 小程序列表
  // sendGroupMessageListObject: [], // 群消息列表
}
export default {
  sendMessageDetail(state = sendMessageState.sendMessageDetail, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_MESSAGE_SEND_DETAIL:
        return payload;
      default:
    }

    return state;
  },
  sendMessagesListObject(state = sendMessageState.sendMessagesListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_MESSAGE_SEND_THEN_OBJECT_LIST:
        return payload;
      default:
    }

    return state;
  },
  sendMessagesListParams(state = sendMessageState.sendMessagesListParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_MESSAGE_SEND_THEN_OBJECT_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  // hasMore(state = sendMessageState.hasMore, action) {
  //   const { type, payload } = action;
  //   switch (type) {
  //     case actionTypes.SET_SELECTED_MESSAGE_SEND_IS_MORE:
  //       return payload;
  //     default:
  //   }

  //   return state;
  // },
  // loading(state = sendMessageState.loading, action) {
  //   const { type, payload } = action;
  //   switch (type) {
  //     case actionTypes.SET_SELECTED_MESSAGE_SEND_LOADING:
  //       return payload;
  //     default:
  //   }

  //   return state;
  // },
  selectedSendMessageList(state = sendMessageState.selectedSendMessageList, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SELECTED_MESSAGE_SEND_SELECTED_LIST:
        return payload;
      default:
    }

    return state;
  },
  sendMessageResult(state = sendMessageState.sendMessageResult, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEND_MESSAGE_RESULT:
        return payload;
      default:
    }

    return state;
  },
  sendMessageRestartSendResult(state = sendMessageState.sendMessageRestartSendResult, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEND_MESSAGE_RESTART_SEND_RESULT:
        return payload;
      default:
    }

    return state;
  },

  sendReissueMessageParams(state = sendMessageState.sendReissueMessageParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEND_REISSUE_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  sendReissueMessageListObject(state = sendMessageState.sendReissueMessageListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEND_REISSUE_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  },
  searchHistoryMessageParams(state = sendMessageState.searchHistoryMessageParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEARCH_HISTORY_MESSAGE_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  searchHistoryMessageListObject(state = sendMessageState.searchHistoryMessageListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEARCH_HISTORY_MESSAGE_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  },
  // sendReissueMessageListId(state = sendMessageState.sendReissueMessageListId, action) {
  //   const { type, payload } = action;
  //   switch (type) {
  //     case actionTypes.SET_SEND_REISSUE_LIST_ID:
  //       return payload;
  //     default:
  //   }

  //   return state;
  // },
  paramsConfigList(state = sendMessageState.paramsConfigList, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_PARAM_CONFIG_LIST:
        return payload;
      default:
    }

    return state;
  },
  sendGroupMessageParams(state = sendMessageState.sendGroupMessageParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SEND_GROUP_MESSAGE_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  selfCreatedSendMessageData(state = sendMessageState.selfCreatedSendMessageData, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SELF_CREATED_SEND_MESSAGE_DATA:
        return payload;
      default:
    }

    return state;
  },
  miniProgramParams(state = sendMessageState.miniProgramParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_MINI_PROGRAM_LIST_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  miniProgramListObject(state = sendMessageState.miniProgramListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_MINI_PROGRAM_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  },
}
